<template lang="pug">
v-card.overflow-hidden.white(outlined)
  slot(
    name="header"
    v-bind="{ showTitle: !hideTitle, title, editableImage }"
  )
    template(v-if="!hideTitle")
      .text-h5.font-weight-medium.mb-2 {{ title }}
    template(v-if="editableImage")
      .mb-7.body-1 Выберите наиболее подходящую область изображения
  slot(
    name="subheader"
    v-bind="{ title, editableImage }"
  )
  template(v-if="editableImage")
    cropper.cropper(
      ref="cropper"
      background-class="redesignBackground"
      :src="editableImage"
      :stencil-props=`{
        aspectRatio,
        handlers: {
          eastNorth: true,
          north: false,
          westNorth: true,
          west: false,
          westSouth: true,
          south: false,
          eastSouth: true,
          east: false,
        }
      }`
    )
  template(v-else)
    drag-and-drop.mt-6(
      v-bind="dndAttrs"
      v-on="dndListeners"
    )
      template(#action="{ pickFile, showIcon, icon, title }")
        app-button.white--text.mt-6(
          color="redesignPrimary"
          @click="pickFile"
        )
          template(v-if="showIcon")
            v-icon(
              :size="20"
              left
            ) {{ icon }}
          | {{ title }}

  slot(
    name="actions"
    v-bind="{ editableImage, crop, replaceImage, deleteImage }"
  )
    template(v-if="editableImage")
      .d-flex.justify-center.mt-7.gap-16
        template(v-if="!hideSaveAction")
          app-button.redesignSuccess--text(
            :disabled="!editableImage"
            color="redesignBackground"
            @click="crop"
          )
            v-icon(
              left
            ) mdi-check
            | Сохранить
        template(v-if="!hideReplaceAction")
          app-button.redesignYellowDarken--text(
            color="redesignBackground"
            @click="replaceImage"
          )
            v-icon(
              :size="24"
              left
            ) $irefresh-outline
            | Заменить
        template(v-if="!hideDeleteAction")
          app-button.redesignError--text(
            color="redesignBackground"
            @click="switchDeleteDialog"
          )
            v-icon(
              :size="20"
              left
            ) $itrash
            | Удалить

  redesign-confirm-dialog(
    message="Вы действительно хотите удалить файл?"
    :value="showDeleteDialog"
    :cancel-handler="switchDeleteDialog"
    :accept-handler="deleteImage"
    :is-server-response="false"
  )
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import RedesignDialog from '@/components/user-redesign/dialogs/RedesignDialog.vue';
import DragAndDrop from '@/components/user-redesign/inputs/AppDragAndDrop.vue';
import RedesignConfirmDialog from '@/components/user-redesign/dialogs/RedesignConfirmDialog.vue';

export default {
  components: {
    Cropper,
    RedesignDialog,
    DragAndDrop,
    RedesignConfirmDialog,
  },
  props: {
    title: {
      type: String,
      default: 'Редактирование обложки',
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    image: {
      type: String,
      default: '',
    },
    aspectRatio: {
      type: Number,
      default: 1,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    hideSaveAction: {
      type: Boolean,
      default: false,
    },
    hideReplaceAction: {
      type: Boolean,
      default: false,
    },
    hideDeleteAction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editableImages: [],
      savedImages: [],
      isReplaced: false,
      showDeleteDialog: false,
      editableImage: this.image,
    };
  },
  computed: {
    fileText() {
      const text = 'файл';

      if (!this.multiple) {
        return text;
      }

      return `${text}ы`;
    },
    dndAttrs() {
      return {
        multiple: this.multiple && !this.isReplaced,
        ...this.$attrs,
      };
    },
    dndListeners() {
      return {
        ...this.$listeners,
        uploaded: this.saveEditableImages,
      };
    },
  },
  watch: {
    editableImage: {
      immediate: true,
      handler(value) {
        this.$emit('update:image', value);
      },
    },
  },
  methods: {
    switchDeleteDialog() {
      this.showDeleteDialog = !this.showDeleteDialog;
    },
    replaceImage() {
      this.isReplaced = true;
      this.editableImage = '';
    },
    deleteImage() {
      if (this.editableImages.length) {
        this.replaceEditableImage([...this.editableImages]);
      } else {
        this.$emit('noImages');
      }
    },
    crop() {
      const { canvas } = this.$refs.cropper.getResult();
      const imageFormat = this.getImageFormat(this.editableImage);
      const croppedImage = canvas.toDataURL(imageFormat);
      this.$emit('cropOne', croppedImage);
      this.savedImages.push(croppedImage);
      if (this.editableImages.length) {
        this.saveEditableImages([...this.editableImages]);
      } else {
        this.$emit('cropAll', this.savedImages);
        this.$emit('noImages');
      }
    },
    saveEditableImages(images) {
      if (this.isReplaced) {
        this.replaceEditableImage(images);
        return;
      }

      const image = images.shift();
      this.editableImage = image;
      this.editableImages = images;
    },
    replaceEditableImage(images) {
      const [image] = images;
      this.editableImage = image;
      this.isReplaced = false;
    },

    getImageFormat(dataUrl) {
      const imageRegExp = /image\/(png|jpeg)/g;
      const data = imageRegExp.exec(dataUrl);
      const [format] = data || [];

      return format || 'image/jpeg';
    },
  },
};
</script>

<style scoped lang="scss">
.cropper {
  height: 100%;
  max-height: 500px;
  min-height: 500px;
}
</style>
